import React, { Component } from 'react';

import imageZigZag from '../images/zigzag.png';

class ZigZag extends Component {
  render() {
    return (
        <img src={imageZigZag} alt="zigzag " className="zigzag" />
    );
  }
}

export default ZigZag;



// WEBPACK FOOTER //
// ./src/components/ZigZag.js